import { render, staticRenderFns } from "./prelimAllocation.vue?vue&type=template&id=c8cc3550&scoped=true&"
import script from "./prelimAllocation.vue?vue&type=script&lang=js&"
export * from "./prelimAllocation.vue?vue&type=script&lang=js&"
import style0 from "./prelimAllocation.vue?vue&type=style&index=0&id=c8cc3550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cc3550",
  null
  
)

component.options.__file = "prelimAllocation.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VFlex,
  VForm,
  VIcon,
})
